var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsLogoJtbcWh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    viewBox: "0 0 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BS_logo_jtbc_wh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 278",
    d: "M6.25854 8.87733C6.28464 10.5231 6.95816 12.0912 8.13145 13.2381C9.30475 14.385 10.8821 15.0169 12.5177 14.9955V11.4993C11.8163 11.5087 11.1398 11.2376 10.6369 10.7456C10.1339 10.2536 9.84561 9.58083 9.83521 8.87507V6.47205H12.5177V2.97885H9.83521V0L6.25854 2.97885V8.87733Z",
    fill: "url(#paint0_linear_5_6718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 279",
    d: "M29.9999 11.1203C29.5792 11.3712 29.0986 11.502 28.6095 11.4989C28.2582 11.5136 27.9077 11.4566 27.5788 11.3314C27.25 11.2063 26.9497 11.0155 26.696 10.7706C26.4423 10.5257 26.2405 10.2316 26.1026 9.90623C25.9647 9.58082 25.8936 9.23073 25.8936 8.87696C25.8936 8.5232 25.9647 8.17308 26.1026 7.84767C26.2405 7.52226 26.4423 7.22827 26.696 6.98335C26.9497 6.73844 27.25 6.54765 27.5788 6.42248C27.9077 6.29732 28.2582 6.24035 28.6095 6.25499C29.0987 6.25216 29.5794 6.38358 29.9999 6.63512V2.911C29.5433 2.81034 29.077 2.76005 28.6095 2.76104C27.7972 2.73887 26.9886 2.88074 26.2317 3.17823C25.4747 3.47573 24.7847 3.92284 24.2023 4.49315C23.6199 5.06347 23.157 5.74542 22.841 6.49875C22.5249 7.25207 22.3621 8.0615 22.3621 8.87921C22.3621 9.69691 22.5249 10.5063 22.841 11.2597C23.157 12.013 23.6199 12.6949 24.2023 13.2653C24.7847 13.8356 25.4747 14.2827 26.2317 14.5802C26.9886 14.8777 27.7972 15.0195 28.6095 14.9974C29.077 14.9984 29.5433 14.9481 29.9999 14.8474V11.1203Z",
    fill: "url(#paint1_linear_5_6718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 280",
    d: "M22.3511 8.87727C22.3519 7.50018 22.8258 6.16568 23.6924 5.09988C22.7955 4.00563 21.5637 3.24101 20.1894 2.92538C18.8151 2.60974 17.3756 2.76086 16.0957 3.35516V0.00292969H12.519V8.88026C12.5447 10.5261 13.2181 12.0945 14.3915 13.2415C15.5649 14.3884 17.1425 15.0203 18.7782 14.9984C19.7191 15.0016 20.6489 14.7935 21.4997 14.3892C22.3505 13.9849 23.1009 13.3946 23.6961 12.6614C22.827 11.5941 22.3518 10.2571 22.3511 8.87727ZM18.7745 11.5015C18.2621 11.4867 17.7654 11.3204 17.3464 11.0232C16.9275 10.7261 16.6048 10.3113 16.4188 9.83064C16.2328 9.35002 16.1916 8.82489 16.3005 8.32088C16.4094 7.81687 16.6635 7.35633 17.031 6.99679C17.3985 6.63725 17.8632 6.39465 18.367 6.29932C18.8707 6.20399 19.3913 6.26016 19.8635 6.46079C20.3357 6.66143 20.7387 6.99764 21.0221 7.42741C21.3055 7.85719 21.4568 8.36148 21.457 8.87727C21.4458 9.58244 21.1572 10.2544 20.6546 10.7458C20.1519 11.2373 19.4761 11.5082 18.7752 11.4992L18.7745 11.5015Z",
    fill: "url(#paint2_linear_5_6718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 281",
    d: "M2.6825 8.87749C2.6723 9.58331 2.38402 10.2562 1.88103 10.7482C1.37803 11.2403 0.701466 11.5113 0 11.5017V14.9979C1.63579 15.0199 3.21348 14.3882 4.3869 13.2412C5.56033 12.0942 6.23365 10.5256 6.25916 8.87973V2.979H2.6825V8.87749Z",
    fill: "url(#paint3_linear_5_6718)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_6718",
    x1: 6.25854,
    y1: 7.49802,
    x2: 12.5177,
    y2: 7.49802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_6718",
    x1: 22.3621,
    y1: 8.87921,
    x2: 29.9999,
    y2: 8.87921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_6718",
    x1: 12.519,
    y1: 7.50095,
    x2: 23.6961,
    y2: 7.50095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_6718",
    x1: 0,
    y1: 8.98873,
    x2: 6.25916,
    y2: 8.98873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsLogoJtbcWh);
export default __webpack_public_path__ + "static/media/BS_logo_jtbc_wh.babc21a343c2e9b9c31bf686c47a3330.svg";
export { ForwardRef as ReactComponent };